import React from "react";
import imgLeft from "../../../Assets/ISO Certification/imgLeft.png";
import imgRight from "../../../Assets/ISO Certification/imgRight.png";

const ISOServiceIndia9001 = () => {
  return (
    <>
      <div className="w-full grid grid-cols-1 md:grid-cols-5 py-5 md:py-10 px-5 sm:px-10 md:px-20 bg-[#F1F9FE]">
        {/* left side image - hidden on mobile */}
        <div className="col-span-1 hidden md:flex">
          <img src={imgLeft} alt="" className="h-auto" />
        </div>

        {/* content  */}
        <div className="flex flex-col col-span-1 md:col-span-3 py-3 md:py-6">
          <div className="font-semibold text-lg md:text-2xl lg:text-3xl text-[#241B1E] text-center">
            <h1>ISO Certification Service in India</h1>
          </div>

          <div>
            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D] text-center mx-0 sm:mx-5 lg:mx-10 mt-2 md:mt-0">
              We provide certification services all across India. We provide
              both IAF Accredited and Non IAF certificates to our client
              depending on their requirement. Our major clients are from medium
              and small scale industries (MSME).
            </p>
          </div>
        </div>

        {/* right side image - hidden on mobile */}
        <div className="col-span-1 hidden md:flex">
          <img src={imgRight} alt="" />
        </div>
      </div>
    </>
  );
};

export default ISOServiceIndia9001;
